import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { HttpError } from 'src/app/shared/models/http-error.model';
import Swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';
import { User } from 'src/app/shared/models/user.model';
import { UserService } from 'src/app/shared/service/user.service';

declare const QRCode: any;

@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit {
  showAlert = true;
  token = '';
  error: any = {};
  code!: string;
  password!: string;
  qrCode!: string;
  isTwoFactorActive = false;
  loading = true;
  showPassword = false;
  showConfirmPassword = false;
  email!: string;
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  verifyCodeLoading = false;
  deActiveLoading = false;

  generateQRCode(text: string) {
    new QRCode(document.getElementById('qrCode'), {
      text: text,
      width: 256,
      height: 256,
      typeNumber:2,
      correctLevel : QRCode.CorrectLevel.L
    });

  }


  constructor(private authService: AuthenticationService, private userService: UserService) {
  }

  getInputType(type: string): string {
    if (type === 'password') {
      if (this.showPassword) {
        return 'text';
      }
      return 'password';
    } else {
      if (this.showConfirmPassword) {
        return 'text';
      }
      return 'password';
    }
  }

  toggleShowPassword(type: string): void {
    if (type === 'password') {
      this.showPassword = !this.showPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  activeTfa(): void {
    this.verifyCodeLoading = true;
    this.error = {};
    this.authService.verifyTwoFactorCode(this.code).subscribe(
      (response: any) => {
        this.isTwoFactorActive = true;
        this.Toast.fire({
          icon: 'success',
          text: 'شناسایی دو عاملی برای شما فعال شد'
        });
        localStorage.setItem('twoFactorTutorial', 'true');
        this.verifyCodeLoading = false;
        this.showAlert = false;
      },
      (response: HttpError) => {
        if (response.status !== 422) {
          this.Toast.fire({ icon: 'error', title: response.error });
        } else {
          this.error = response.validationError;
        }
        this.verifyCodeLoading = false;
      }
    );
  }

  disableTfa(): void {
    this.error = {};
    this.deActiveLoading = true;
    this.authService.disableTwoFactor(this.password).subscribe(
      (response: any) => {
        this.isTwoFactorActive = false;
        this.Toast.fire({
          icon: 'success',
          text: 'شناسایی دوعاملی با موفقیت غیر فعال شد'
        });
        this.deActiveLoading = false;
      },
      (response: HttpError) => {
        if (response.status !== 422) {
          this.Toast.fire({ icon: 'error', title: response.error });
        } else {
          this.error = response.error;
        }
        this.deActiveLoading = false;
      }
    );
  }

  copyText(): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.token;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.Toast.fire({
      icon: 'success',
      text: 'کد بازیابی کپی شد.'
    });
  }

  getSecretKey(): void {
    this.authService.getSecretKey().subscribe(
      (response: any) => {
        this.loading = false;
        this.isTwoFactorActive = false;
        this.token = response.data;
        this.qrCode = `otpauth://totp/Nesoex(${this.email})?secret=${this.token}&issuer=Nesoex(${this.email})`;
        this.generateQRCode(this.qrCode);
      },
      (response: HttpError) => {
        this.loading = false;
        if (response.status === 400) {
          this.isTwoFactorActive = true;
        } else {
          this.Toast.fire({ icon: 'error', title: response.error });
        }
      }
    );
  }

  ngOnInit(): void {
    if (localStorage.getItem('twoFactorTutorial')) {
      this.showAlert = false;
    }
    this.userService.userStream.subscribe((user) => {
      this.email = user.email;
    });
    this.getSecretKey();
  }
}
